
import { mapState, mapMutations, mapActions } from 'vuex'

import Header from '~/components/Common/Layout/Header'
import Footer from '~/components/Common/Layout/Footer'
import Alert from '~/components/Common/Modal/Alert'
import LoginModal from '~/components/Common/Modal/LoginModal'
// import FindId from '~/components/Common/Modal/FindId'
import Findinfo from '~/components/Common/Modal/Findinfo'
import RegularMemberJoin from '~/components/Common/Modal/RegularMemberJoin'
import RegularMemberWelcome from '~/components/Common/Modal/RegularMemberWelcome'
import Deposit from '~/components/Common/Modal/Deposit'

let bodyEl = null

export default {
    components: {
        Header,
        Footer,
        Alert,
        LoginModal,
        // FindId,
        Findinfo,
        RegularMemberJoin,
        RegularMemberWelcome,
        Deposit,
    },

    computed: {
        ...mapState('modal', [
            'alertShow',
            'loginShow',
            'findIdShow',
            'regularMemberJoinShow',
            'regularMemberWelcomeShow',
            'depositShow',
            'depositInfo',
        ]),
        ...mapState('ui', ['mobileMenuShow']),
        // ...mapState({ alertShow: (state) => state.modal.show }),

        overlayShow() {
            return (
                this.depositInfo.show ||
                this.depositShow ||
                this.mobileMenuShow ||
                this.regularMemberJoinShow ||
                this.regularMemberWelcomeShow ||
                this.findIdShow ||
                this.loginShow ||
                this.alertShow
            )
        },
    },

    watch: {
        overlayShow(newVal, oldVal) {
            console.log('overlayShow newVal, oldVal', newVal, oldVal)

            bodyEl = bodyEl || document.getElementsByTagName('body')[0]

            newVal
                ? bodyEl.classList.add('scrollHidden')
                : bodyEl.classList.remove('scrollHidden')
        },
    },

    mounted() {
        // 테스트
        // setTimeout(() => this.SHOW_ALERT('모달 내용'), 1000)
    },

    methods: {
        ...mapActions('modal', ['SHOW_ALERT', 'HIDE_MODAL']),
        ...mapMutations('ui', ['SET_MOBILE_MENU_SHOW']),

        onClickOverLayArea(e) {
            const target = e.target.classList

            if (target.value.includes('login-container-parent overlay')) {
                this.HIDE_MODAL()
                this.SET_MOBILE_MENU_SHOW(false)
            }
        },

        // 22.07.12 suye 키누르면 모달닫기
        keyClose(){
            this.HIDE_MODAL()
        },
    },
}
